/** All supported weight units */
export type WeightUnit = 'Ounces' | 'Pounds' | 'Grams' | 'Kilograms';
export type BaseWeightUnit = 'Ounces' | 'Grams';
export type MajorWeightUnit = 'Pounds' | 'Kilograms';

export const WEIGHT_UNIT_OUNCES: BaseWeightUnit = 'Ounces';
export const WEIGHT_UNIT_GRAMS: BaseWeightUnit = 'Grams';
export const WEIGHT_UNIT_POUNDS: MajorWeightUnit = 'Pounds';
export const WEIGHT_UNIT_KILOGRAMS: MajorWeightUnit = 'Kilograms';

/** Seller settings API values (singular form) */
export const WEIGHT_SETTING_OUNCE = 'Ounce';
export const WEIGHT_SETTING_GRAM = 'Gram';

/** Weight value with unit */
export type Weight = {
  value: number;
  unit: WeightUnit;
};
